export default __webpack_public_path__ + "static/media/OpenSans-Italic.a397a4c1.ttf";